import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { DialogService } from "../../common/services/dialog.service";

import { SubHeader } from '../models/sub-header.model';
import { SubHeaderService } from '../services/sub-header.service';

@Component({
    selector: 'app-auth-required',
    templateUrl: './auth-required.component.html',
    standalone: false
})
export class AuthRequiredComponent implements OnInit {
  public isLoggedIn: boolean = false;

  constructor(
    public _authService: AuthService,
    public _location: Location,
    public _subHeaderService: SubHeaderService,
    public activatedRoute: ActivatedRoute,
    public dialogService: DialogService,
    public router:Router
  ) {
  }

  ngOnInit() {
    if (this._authService.verifyCanLogin()) {
      this.dialogService.openDialog('exit', 'Your account has been disabled.');
    }
    this.isLoggedIn = this._authService.isLoggedIn;
    this._subHeaderService.updateSubHeader(new SubHeader({ title: "Home" }));
  }

  public goBack(): void {
    this._location.back();
  }

  public logIn(url: string): void {
    //this.router.navigate(["auth","login"]);

    window.location.href = "/api/login";
    //this._authService.loginWithRedirect(url);
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    this._authService.logout();
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}
